export default __webpack_public_path__ + "static/media/Ksana-Health-EARS-2point0-logo-reversed.6ef4cd12.png";